import { CDN_LINK } from "@globalConfig";
import { mojazReport } from "../../../../../utils/dataLayerEvents";
import stl from "./MojazSection.module.css";

const MojazSection = ({ t, data, g4_data, screen_view_referral }) => {
  return (
    <div className={stl.wrapper}>
      <div className={`${stl.row} ${stl.head}`}>
        <strong>{t("نبذة من تقرير موجز", { ns: "web_post_view" })}</strong>
        <img src={CDN_LINK + "/assets/images/mojaz-logo.svg"} alt="" />
      </div>

      <div className={`${stl.row} ${stl.body}`}>
        {data?.total_owners && (
          <div className={stl.section}>
            <img
              src={CDN_LINK + "/assets/images/mojaz-icon-1.svg"}
              alt=""
            />

            <div>
              <span>{t("عدد المُلّاك", { ns: "web_post_view" })}</span>
              <strong>{data?.total_owners}</strong>
            </div>
          </div>
        )}

        {data?.last_odometer_reading && (
          <div className={stl.section}>
            <img
              src={CDN_LINK + "/assets/images/mojaz-icon-2.svg"}
              alt=""
            />

            <div>
              <span>{t("قراءة العداد", { ns: "web_post_view" })}</span>
              <strong>
                {data?.last_odometer_reading}{" "}
                <span>{t("كم", { ns: "web_post_view" })}</span>{" "}
              </strong>
            </div>
          </div>
        )}
      </div>

      <div className={`${stl.row} ${stl.footer}`}>
        <a
          rel="noopener noreferrer" target="_blank"
          rel="nofollow"
          href={data?.full_report_url}
          onClick={() =>
            mojazReport("mojaz_report", screen_view_referral, g4_data)
          }
          rel="nofollow"
        >
          {t("اطّلع على تقرير موجز كاملاً", { ns: "web_post_view" })}
        </a>
        <img
          src={CDN_LINK + "/assets/images/red-arrow-left.svg"}
          alt=""
        />
      </div>
    </div>
  );
};

export default MojazSection;
